import DOMPurify from 'dompurify';
import { HTMLAttributes } from 'react';

interface SafeHtmlProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'dangerouslySetInnerHTML'> {
  html: string;
  sanitizeOptions?: Parameters<typeof DOMPurify.sanitize>[1];
}

const SafeHtml = ({ html, sanitizeOptions, ...props }: SafeHtmlProps) => {
  const sanitizedHtml = DOMPurify.sanitize(html, sanitizeOptions);

  return <div {...props} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default SafeHtml;

